import React from 'react'
import { Link } from 'react-router-dom'

const Policy = () => {
    return (
        <>
            <section id="policy-page" className="policy-page-main-block">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="policy-page-block">
                                <div className="policy-page-dtl">
                                    <h6 className="policy-heading">
                                        Return and Refund Policy Overview:
                                    </h6>
                                    <p>
                                        Our return and refund policy has a duration of 30 days from the
                                        date of purchase. If 30 days have elapsed since your purchase, we
                                        regret to inform you that we cannot offer a full refund or
                                        exchange. <br />
                                        To be eligible for a return, the item must be unused and in the
                                        same condition as when you received it. It should also be in its
                                        original packaging. <br />
                                        Certain types of goods are exempt from being returned, including
                                        perishable items like food, flowers, newspapers, or magazines.
                                        Additionally, we do not accept returns for intimate or sanitary
                                        goods, hazardous materials, or flammable liquids and gases.
                                    </p>
                                </div>
                                <div className="policy-page-dtl">
                                    <h6 className="policy-heading">
                                        The following items are non-returnable:
                                    </h6>
                                    <ul className="policy-lst">
                                        <li>Gift cards</li>
                                        <li>Downloadable software products</li>
                                        <li>Some health and personal care items</li>
                                    </ul>
                                    <p>
                                        To complete a return, a receipt or proof of purchase is required.
                                        Please avoid sending the purchase back to the manufacturer.
                                    </p>
                                </div>
                                <div className="policy-page-dtl">
                                    <h6 className="policy-heading">
                                        Partial refunds may be granted in specific situations, such as:
                                    </h6>
                                    <ul className="policy-lst">
                                        <li>Books with obvious signs of use</li>
                                        <li>
                                            Opened CDs, DVDs, VHS tapes, software, video games, cassette
                                            tapes, or vinyl records
                                        </li>
                                        <li>
                                            Items not in their original condition, damaged, or missing parts
                                            for reasons not due to our error
                                        </li>
                                        <li className="days">
                                            Items returned more than 30 days after delivery
                                        </li>
                                    </ul>
                                </div>
                                <div className="policy-page-dtl">
                                    <h6 className="policy-heading">Refunds Process:</h6>
                                    <p>
                                        Upon receiving and inspecting your returned item, we will notify
                                        you via email regarding the approval or rejection of your refund.
                                        If approved, the refund will be processed, and a credit will
                                        automatically be applied to your credit card or original method of
                                        payment within a specified timeframe.
                                    </p>
                                </div>
                                <div className="policy-page-dtl">
                                    <h6 className="policy-heading">Late or Missing Refunds:</h6>
                                    <p>
                                        If you haven't received a refund, please check your bank account
                                        and contact your credit card company. If the issue persists,
                                        contact your bank. For further assistance, reach out to us at{" "}
                                        {"{"}email address{"}"}. <br />
                                        Sale Items: <br />
                                        Refunds are applicable only to regular-priced items; sale items
                                        are non-refundable.
                                    </p>
                                </div>
                                <div className="policy-page-dtl">
                                    <h6 className="policy-heading">Exchanges:</h6>
                                    <p>
                                        We only replace items that are defective or damaged. If you need
                                        to exchange a defective or damaged item, please email us at {"{"}
                                        email address{"}"} and send the item to: {"{"}physical address
                                        {"}"}. <br />
                                        Gifts: <br />
                                        If the item was marked as a gift and shipped directly to you,
                                        you'll receive a gift credit for the return value. If the item
                                        wasn't marked as a gift, the refund will be issued to the gift
                                        giver.
                                    </p>
                                </div>
                                <div className="policy-page-dtl">
                                    <h6 className="policy-heading">Shipping Returns:</h6>
                                    <p>
                                        To return a product, mail it to: {"{"}physical address{"}"}. You
                                        are responsible for the return shipping costs, which are
                                        non-refundable. Consider using a trackable shipping service or
                                        purchasing shipping insurance for more expensive items, as we
                                        cannot guarantee receipt of your returned item.
                                    </p>
                                    <p className="mt-5">
                                        For assistance, contact us at {"{"}email{"}"}.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="policy-questions">
                                <h6 className="policy-heading">Have Any More Questions?</h6>
                                <p>
                                    If you have any inquiries or concerns regarding our shipping policy,
                                    feel free to reach out to our customer service team.
                                </p>
                                <Link to="/Contactus" title="" className="btn btn-primary">
                                    Contact Us
                                    <i className="flaticon-right-arrows" />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Policy
